export default "assets/frame-2.9f200994919edf8c.png"